import { useIntl } from 'react-intl';
import { Card, Grid } from 'semantic-ui-react';

// COMPONENTS
import {
  CardHeader,
  DatePickerRow,
  DatePickerContainer,
  StyledRentalLinks,
} from 'views/Agreement/cards/AgreementCards.styles';
import CustomDatePicker from 'components/DatePicker';
import { StyledRentalDetailsCard } from './styles';
import InformationIcon from 'assets/AgreementIcons/Information';
import CarInIcon from 'assets/AgreementIcons/CarIn';
import CarOutIcon from 'assets/AgreementIcons/CarOut';

// STYLES
import colors from 'styles/colors';

export const RentalDetailsModalCard = ({ dateOut, dateDue, setDateOut, setDateDue, errors }) => {
  const { formatMessage } = useIntl();

  const error = errors?.dateDue;

  return (
    <StyledRentalDetailsCard>
      <CardHeader>
        <InformationIcon color={colors.fleetBlue} />
        {formatMessage({ id: 'views.Agreement.rentalDetails' })}
      </CardHeader>
      <Card.Content>
        <Grid columns={1}>
          <DatePickerRow>
            <DatePickerContainer>
              {/* @ts-expect-error TS(2740): Type '{ name: string; label: { translationId: stri... Remove this comment to see the full error message */}
              <CustomDatePicker
                name="dateOut"
                label={{ translationId: 'services.Agreements.dateOut' }}
                selected={dateOut}
                setSelected={setDateOut}
                startDate={dateOut}
                endDate={dateDue}
                selectsStart
              />
              <CarOutIcon />
            </DatePickerContainer>
            <StyledRentalLinks />
            <DatePickerContainer>
              <CarInIcon />
              {/* @ts-expect-error TS(2739): Type '{ name: string; label: { translationId: stri... Remove this comment to see the full error message */}
              <CustomDatePicker
                name="dateDue"
                label={{ translationId: 'services.Agreements.dateDue' }}
                selected={dateDue}
                setSelected={setDateDue}
                startDate={dateOut}
                endDate={dateDue}
                minDate={dateOut}
                error={error ? formatMessage(error) : false}
                selectsEnd
              />
            </DatePickerContainer>
          </DatePickerRow>
        </Grid>
      </Card.Content>
    </StyledRentalDetailsCard>
  );
};

export default RentalDetailsModalCard;
